import { createTheme, ThemeProvider } from "@mui/material";
import { PropsWithChildren } from "react";

const theme = createTheme({
    shape: {
        borderRadius: 0
    },
    palette: {
        action: {
            hover: "rgba(0, 0, 0, 0)"
        },
        text: {
            primary: "black",
            secondary: "black",
            disabled: "black"
        }
    },
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    borderWidth: "0px"
                }
            }
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    borderWidth: "0px",
                    paddingTop: "3px",
                    paddingBottom: "3px"
                },
                head: {
                    borderBottom: "1px solid #000000",
                },
                footer: {
                    fontSize: '0.875rem',
                    fontWeight: 500,
                    lineHeight: 1.5,
                }
            }
        }
    },
    typography: {
        h1: {
            fontWeight: "bold",
        },
        h2: {
            fontWeight: "bold"
        },
        h3: {
            fontWeight: "bold"
        },
        h4: {
            fontWeight: "bold"
        },
        h5: {
            fontWeight: "bold"
        },
        h6: {
            fontWeight: "bold"
        },
        subtitle1: {
            fontWeight: "bold"
        },
        subtitle2: {
            fontWeight: "bold"
        }
    }
});

export default function PrintThemeProvider({
    children
}: PropsWithChildren) {
    return <ThemeProvider theme={theme}>
        {children}
    </ThemeProvider>
}